import { NavLink } from 'react-router'
import { cn } from '@/shared/lib/utils'
import {
  NavHomeIcon,
  NavEnquiriesIcon,
  NavCasesIcon,
  NavInvoicesIcon,
  NavDsaIcon,
} from '@/shared/components/navigation/nav-icons'

// Five core destinations only. Profile moved to the header avatar, so the bar stays thumb-friendly
// and uncrowded. A floating glass bar rather than a full-width strip: it reads as a modern app
// dock, keeps clear of the screen edges, and the active item lifts into a soft brand pill.
const navItems = [
  { to: '/', label: 'Home', icon: NavHomeIcon },
  { to: '/enquiries', label: 'Enquiries', icon: NavEnquiriesIcon },
  { to: '/cases', label: 'Cases', icon: NavCasesIcon },
  { to: '/invoices', label: 'Invoices', icon: NavInvoicesIcon },
  { to: '/dsa-codes', label: 'DSA', icon: NavDsaIcon },
] as const

export function MobileNav() {
  return (
    <div
      className="pointer-events-none fixed inset-x-0 bottom-0 z-50 flex justify-center pb-[max(0.75rem,env(safe-area-inset-bottom))] lg:hidden"
      aria-hidden={false}
    >
      <nav
        aria-label="Main navigation"
        className="pointer-events-auto mx-3 flex w-full max-w-md items-stretch gap-1 rounded-2xl border border-white/60 bg-white/80 p-1.5 shadow-[0_8px_30px_rgba(15,34,58,0.16)] backdrop-blur-xl"
      >
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className="group relative flex flex-1 flex-col items-center justify-center rounded-xl py-2"
          >
            {({ isActive }) => (
              <>
                {/* Soft brand pill lifts the active item. */}
                <span
                  aria-hidden="true"
                  className={cn(
                    'absolute inset-0 rounded-xl transition-all duration-200 ease-out',
                    isActive ? 'scale-100 bg-brand-50 opacity-100' : 'scale-90 opacity-0'
                  )}
                />
                <span
                  className={cn(
                    'relative transition-colors duration-200',
                    isActive ? 'text-brand-600' : 'text-neutral-400 group-active:text-navy-600'
                  )}
                >
                  <Icon className="h-6 w-6" aria-hidden="true" />
                </span>
                <span
                  className={cn(
                    'relative mt-1 text-[10px] leading-none transition-colors duration-200',
                    isActive ? 'font-semibold text-brand-700' : 'font-medium text-neutral-400'
                  )}
                >
                  {label}
                </span>
                {isActive && <span className="sr-only">, current page</span>}
              </>
            )}
          </NavLink>
        ))}
      </nav>
    </div>
  )
}
